var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 161,
    viewBox: "0 0 162 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 161C36.542 161 0.5 124.958 0.5 80.5C0.5 36.042 36.542 0 81 0C125.458 0 161.5 36.042 161.5 80.5C161.5 124.958 125.458 161 81 161ZM81 14.6364C44.592 14.6364 15.1364 44.092 15.1364 80.5C15.1364 116.908 44.592 146.364 81 146.364C117.408 146.364 146.864 116.908 146.864 80.5C146.864 44.092 117.408 14.6364 81 14.6364Z",
    fill: "#94949A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0006 96.9659C76.9756 96.9659 73.6824 93.6727 73.6824 89.6477V47.5682C73.6824 43.5432 76.9756 40.25 81.0006 40.25C85.0256 40.25 88.3187 43.5432 88.3187 47.5682V89.6477C88.3187 93.6727 85.0256 96.9659 81.0006 96.9659Z",
    fill: "#94949A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9993 121.119C85.041 121.119 88.3175 117.842 88.3175 113.8C88.3175 109.759 85.041 106.482 80.9993 106.482C76.9576 106.482 73.6811 109.759 73.6811 113.8C73.6811 117.842 76.9576 121.119 80.9993 121.119Z",
    fill: "#94949A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9958 122.946C75.8731 122.946 71.8481 118.921 71.8481 113.798C71.8481 108.676 75.8731 104.651 80.9958 104.651C86.1185 104.651 90.1435 108.676 90.1435 113.798C90.1435 118.921 86.1185 122.946 80.9958 122.946ZM80.9958 108.31C77.8856 108.31 75.5072 110.688 75.5072 113.798C75.5072 116.909 77.8856 119.287 80.9958 119.287C84.106 119.287 86.4844 116.909 86.4844 113.798C86.4844 110.688 84.106 108.31 80.9958 108.31Z",
    fill: "#94949A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.0a6dc60803cd913242a97ff0c91ef87d.svg";
export { ForwardRef as ReactComponent };